import FinancialDetailsModule from '@/modules/financial-details';

const FinancialDetails = () => {
  return <FinancialDetailsModule />;
};

export default FinancialDetails;
